import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { ApiResponse } from '../shared/types';

export interface OpenLaneGateResponse {
  status?: string | boolean;
  delivered?: number;
  delivery?: string;
  laneId?: string;
  serial?: string;
  name?: string;
  message?: string;
}

@Injectable({
  providedIn: 'root',
})
export class GateService {
  constructor(private readonly apiService: ApiService) {}

  openLaneGate(locationId: string, laneId: string): Observable<OpenLaneGateResponse> {
    return this.apiService
      .post<OpenLaneGateResponse>(`devices/location/${locationId}/lanes/${laneId}/open`, {})
      .pipe(
        map((response: ApiResponse<OpenLaneGateResponse>) => {
          if (response.status === false) {
            throw response;
          }
          const payload = response.data ?? (response as any as OpenLaneGateResponse);
          // Backend returns 503 when the controller is offline. Defend against
          // any 2xx body that still reports no delivery.
          if (payload?.delivery === 'none' || Number(payload?.delivered ?? 0) < 0) {
            throw {
              status: false,
              message:
                payload?.message ||
                'Gate controller is offline or did not receive the command.',
              data: payload,
            };
          }
          return payload;
        })
      );
  }
}
